export const fileToBase64 = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
	  const reader = new FileReader();
	  reader.readAsDataURL(file);
	  reader.onload = () => {
		const result = reader.result as string;
		// Remover el prefijo "data:application/pdf;base64," y solo enviar el Base64
		const base64 = result.split(',')[1];
		resolve(base64);
	  };
	  reader.onerror = error => reject(error);
	});
};
 
export const getMimeTypeBasedOnFilename = (filename: string) => {
  if (!filename || !filename.includes('.')) return ''
  const splitted = filename.split('.')
  const extension = splitted[splitted.length - 1].toLowerCase()
   
  if (extension === 'png') return 'image/png'
  if (extension === 'pdf') return 'application/pdf'
  if (extension === 'txt') return 'text/plain'
  return ''
}